<template>
  <div id="app">
    <router-view />
	 <!-- <div>{{isWeChat ? '是微信' : '不是微信'}}</div> -->
	 <custom-message v-if="globalMessage" :message="globalMessage" :messageType="messageType"/>
  </div>
</template>

<script>
import { getvxuserinfo } from "./plugins/api.js"	
export default {
	name: 'App',
   data() {
		return {
			isWeChat: false,
			globalMessage: '',
			messageType: '',
			vx_open_id: '',
		}
   },
	
	created() {
		//自定义提示信息
	   this.$root.$on('showMessage', (data) => {
	      this.globalMessage = data.globalMessage ? data.globalMessage : ''//默认为空
			this.messageType = data.messageType ? data.messageType : 'success'//默认成功
			let time = data.messageTime ? data.messageTime : 2000 //默认2秒
	      setTimeout(() => {
	        this.globalMessage = ''; // 隐藏提示
	      }, time); // 显示一段时间后自动隐藏
	   });
		//获取授权
		this.$root.$on('authorize', (data) => {
			var url = data.url
		   return this.authorize(url)
		});
	},
	
	mounted(){
		this.checkWeChat();
	},
	
	methods: {
		// 获取授权
		authorize(url) {
		  // 构造微信授权URL
		  const redirectUri = url ? 'https://gzhweb.tozo.com.cn/' + url : 'https://gzhweb.tozo.com.cn/index'; // 回调URL
		  const appId = 'wx5457e1434cfcba03'; // AppID
		  const scope = 'snsapi_base'; // snsapi_base基础授权，只获取openid, snsapi_userinfo获取到用户的基本信息以及用户授权后的详细信息
		  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;
				
		  // 跳转到微信授权页面
		  window.location.href = authUrl;
		},
		
		//判断是否在微信端
		checkWeChat() {
			const userAgent = navigator.userAgent.toLowerCase();
			console.log(userAgent)
			if (userAgent.indexOf('micromessenger') !== -1) {
			  this.isWeChat = true;
			  localStorage.setItem('isWeChat', 'true')
			}else{
				localStorage.setItem('isWeChat', 'false')
			}
		},
	}
}
</script>

<style lang='less'>
	.template_box{
		width: 100%;
		min-height: 100vh;
		display: flex;
		justify-content: center;
		background-color: #000;
	}
	.header_box{
		display: flex;
		z-index: 999;
		padding: 10px 10px;
		box-sizing: border-box;
		width: 100%;
		justify-content: space-between;
		position: fixed;
		top: 0;
		background-color: #fff;
		div{
			width: 30%;
			&:nth-child(1){
				text-align: left;
				width: 15%;
			}
			&:nth-child(2){
				text-align: center;
				color: #666666;
				width: 70%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			&:nth-child(3){
				width: 15%;
				text-align: right;
			}
		}
		.go_back{
			cursor:pointer;
			img{
				width: 30px;
			}
		}
		.Sunbathing{
			font-size: 17px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #000000;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.content_box {
		background-color: #000000;
	   /* margin-top: 45px; */
	   width: 100%;
	   max-width: 1024px;
	   min-height: 100vh;
	   text-align: center;
	   box-sizing: border-box;
	   padding: 0 12px;
	}
	
@media screen and (max-width: 450px) {
  .el-notification {
    width: 90%;
  }
}
</style>
